import React from 'react';

import { Form as AntForm } from 'antd';
import { ErrorListProps } from 'antd/lib/form/ErrorList';

const { Item: AntErrorList } = AntForm;

export interface IErrorListProps extends ErrorListProps {}

export const ErrorList: React.FC<ErrorListProps> = (props) => (
  <AntErrorList {...props} />
);
